module.exports = __webpack_public_path__ + "static/img/point-icon-img@t.2626baa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lotte-tms/point-icon-img@t.png
// module id = YJ1J
// module chunks = 0